import type {ReactNode} from 'react';
import {useReducer} from 'react';

import {CountryListContext} from './CountryListContext';
import type {CountryListAction, CountryListState} from './types';
import {CountryListActionType} from './types';

const initialState: CountryListState = {
  loading: false,
  countryList: [],
};

const reducer = (
  state: CountryListState,
  action: CountryListAction,
): CountryListState => {
  switch (action.type) {
    case CountryListActionType.FETCH_COUNTRIES:
      return {...state, ...action.payload};
    default:
      return state;
  }
};

export const CountryListProvider = ({children}: {children: ReactNode}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <CountryListContext.Provider value={{state, dispatch}}>
      {children}
    </CountryListContext.Provider>
  );
};
